import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PatientToMergeAlert } from 'modules/Hcp';
import PatientHeader from './PatientHeader';
export const renderPatientHeader = (onDataSync)=>(isPhiInProgress)=>/*#__PURE__*/ _jsx(PatientHeader, {
            isPhiInProgress: isPhiInProgress,
            onSync: onDataSync
        });
export const renderContextAlerts = ()=>/*#__PURE__*/ _jsx(PatientToMergeAlert, {});
